import { Route } from '@angular/router';
import { SharingComponent } from './sharing.component';

export const SharingRoutes: Route[] = [
  {
    path: 'sharing',
    component: SharingComponent
  }
];
